export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";